import { createContext, useContext } from 'react';

export interface ApiConfig {
  baseUrl: string;
  apiUrl: string;
  auth: string;
  storage: string;
}

export interface AwsConfig {
  region: string;
  cognito: {
    userPoolId: string;
    userPoolWebClientId: string;
    domain: string;
  };
}

export interface RumConfig {
  appId: string;
  appVersion: string;
  guestRoleArn: string;
  identityPoolId: string;
}

export interface AppConfig {
  stage: string;
}

export interface AppConfiguration {
  api: ApiConfig;
  aws: AwsConfig;
  rum: RumConfig;
  app: AppConfig;
}

export interface ConfigContextType {
  config: AppConfiguration;
  isLoading: boolean;
  error: Error | null;
}

export const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};
